export const NORMALIZE_CSS =
    '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css" />';

// FUN-3908: Placeholder height for standalone AI embeds while the sandbox is
// still loading. AI blocks typically hold the main page content, so reserving
// most of the viewport keeps blocks below the embed (e.g. a CTA button) from
// flashing near the top of the page and jumping down once the real height
// arrives. Only applied when the embed is not inside a layout column.
export const AI_EMBED_LOADING_MIN_HEIGHT = '900px'; // iPhone viewport height is 874px

// CVT-4096: How long the reported height has to stay unchanged before it counts
// as the embed's final height. The sandbox reports every intermediate height
// while async content lands (a Tailwind CDN build, webfonts, images), so
// releasing the placeholder on the first report would reintroduce the jump
// FUN-3908 fixed. Long enough to bridge those, short enough to be unnoticeable.
export const EMBED_HEIGHT_SETTLE_DEBOUNCE_MS = 250;

// CVT-4096: Hard cap on the loading placeholder. A sandbox that never loads, or
// an embed that animates its height indefinitely, must not reserve the viewport
// forever.
export const EMBED_HEIGHT_SETTLE_TIMEOUT_MS = 5000;

// CAP-4418: How often the sandbox re-measures its own content after injecting
// it. The sandbox's dimensions updates are driven by a ResizeObserver, and
// browsers do not run the rendering steps that deliver ResizeObserver callbacks
// for a cross-origin iframe that is entirely offscreen — which every embed below
// the fold is, not least because of the loading placeholder above it. Such an
// embed would otherwise keep the height it happened to have one task after
// injection, before its stylesheets, webfonts and images landed, and stay
// collapsed for the whole visit. A timer is not subject to that throttling.
export const EMBED_HEIGHT_POLL_INTERVAL_MS = 200;

// CAP-4418: Hard stop for the polling. The sandbox keeps measuring for this
// whole window rather than stopping once the height holds steady, because for an
// offscreen embed it is the only channel left — but it must not go on measuring
// for the lifetime of the page.
export const EMBED_HEIGHT_POLL_TIMEOUT_MS = 10000;

// CAP-4418: How long after the sandbox reports its injected content the height
// may first be treated as final. The first measurement is taken before the
// embed's own stylesheets, Tailwind CDN build and webfonts have applied, and an
// embed that renders nothing for a few hundred ms produces no height change for
// the settle debounce to notice — so it would otherwise be declared settled at a
// fraction of a pixel, and the page revealed around a block that is about to
// grow. Measured on the reporting funnel, the embeds reach their real height
// ~400ms after injection.
export const EMBED_MIN_RENDER_MS = 500;
